import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import { replaceStart } from 'rise-ui/utils/string.js';

export default class TransitionToComponent extends Component {
  @service router;

  @action onClick(e) {
    const href = '' + (this.args.href || '');
    if (href) {
      this.router.transitionTo(replaceStart(href, this.router.rootURL, '/'));
    }
    e.preventDefault();
  }

  <template>
    <a href={{@href}} {{on "click" this.onClick}}>{{yield}}</a>
  </template>
}
